import { Document, Page } from 'react-pdf';
import styled from 'styled-components';

const pdfPaginationHeight = '65.5px'; // 65.5px is the height of the pagination component + the gap between the pagination and the pdf

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: #aab1c7;
  height: 100%;
`;

export const PdfWrapper = styled.div`
  flex: 0 0 calc(100% - ${pdfPaginationHeight});
  max-height: calc(100% - ${pdfPaginationHeight});
  display: flex;
  justify-content: center;
`;

export const PaginationWrapper = styled.div`
  flex: 0 0 auto;
`;

export const StyledDocument = styled(Document)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledPage = styled(Page)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;

  &.inactive {
    display: none;
  }

  &.active {
    display: inherit;
  }
`;
